import IndexLinks from "../IndexLinks";

const HelpTopicPaiementIndex = () => {
  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: "Paiements, tarification et remboursements", link: '/topics/paiement'},
  ]

  const links = [
    { title: 'Payer une inscription', link: '/topics/paiement/payer-inscription'},
    { title: 'Remboursements', link: '/topics/paiement/remboursements'},
    { title: 'Tarification et frais', link: '/topics/paiement/tarification'},
    { title: 'Factures et reçus', link: '/topics/paiement/factures'},
  ]

  return <IndexLinks goBackLinks={goBackLinks} links={links}/>
}

export default HelpTopicPaiementIndex